<template>
<div :class="{
        'home-close-view':true,
        'home-close-view-no-TocaApp':!is_inTocaApp
    }">
        <div v-if="is_inTocaApp && isHome" class="line"></div>
        <moo-popover :close-delay="0" popper-class="cloud-home-close-popper" placement="top" trigger="hover" :content="$t('关闭#!!!#src/pages/H5/Cloud/components/popper/closePopper.vue_1')">
            <div @click="closePopper" slot="reference" class="wiki-top">
                <svg-icon slot="reference" iconClass="cloud-home-close-icon" class="header-icon cloud-home-close-icon"></svg-icon>
            </div>
        </moo-popover>
    </div>
</template>

<script>
export default {
    name: 'OpenPopper',
    props:{
        isHome:{
            type:Boolean,
            default:true
        },
        isWiki:{
            type:Boolean,
            default:true
        },
        is_inTocaApp: {
            type:Boolean,
            default:false
        }
    },
    methods:{
        closePopper(){
            console.log('closePopper')
            if(this.is_inTocaApp) {
                if(this.isWiki && this.isHome){
                    window.parent.postMessage("home-close", "*");
                }
                window.close();
                return
            }
            if(this.isHome) {
                window.parent.postMessage("home-close", "*");
            }
        }
    }
}
</script>

<style lang="scss">
.home-close-view-no-TocaApp{
    margin-left: 17px;
}

.home-close-view {
    height:100%;
    display: flex;
    flex-flow: row;
    align-items: center;

    .line {
        width: 1px;
        height: 16px;
        background: #e2e6ed;
        border-radius: 1px;
        margin: 0 16px;
    }
}

.cloud-home-close-popper {
    width: 44px !important;
    min-width: 44px !important;
    padding: 0 !important;
    /* margin: 0 !important; */
    margin-bottom: 5px !important;
    line-height: 36px !important;
    text-align: center !important;
    height: 36px !important;
    background: #FFFFFF !important;
    box-shadow: 0 8px 12px 0 #1213171a !important;
    border-radius: 8px !important;
    font-weight: 400;
    font-size: 14px;
    color: #767C85;
    box-sizing: border-box;

    .popper__arrow {
        display: none !important;
    }
}

.cloud-home-close-icon {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    width: 16px;
    height: 16px;

    &:hover {
        background: #f4f6f9;
        border-radius: 4px;
    }
}
</style>
